import React from "react"
import { FormattedMessage } from "react-intl"
import { Box, Button, Divider, Typography, useTheme } from "@carrotfertility/carotene-core"

// @ts-expect-error TS(7031) FIXME: Binding element 'returnToLink' implicitly has an '... Remove this comment to see the full error message
const UnknownErrorOccurred = ({ returnToLink }) => {
  const theme = useTheme()
  return (
    <div className="flex-auto flex flex-column justify-center items-center vh-100">
      <div className={`br3 bg-white ba b--mint-alternate animate-all mw6-ns mw5 pv4`}>
        <div className="tc pa4">
          <Typography variant="h3">
            <FormattedMessage defaultMessage="An unknown error occurred." />
          </Typography>
          <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xxs })}>
            <Typography color={(theme) => theme.palette.text.secondary}>
              <FormattedMessage defaultMessage="Please refresh the page and try again." />
            </Typography>
          </Box>
          <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.lg })}>
            <Divider sx={{ borderWidth: 2, borderColor: theme.palette.secondary.light }} />
          </Box>
          <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.lg })}>
            <div className="flex flex-row justify-between">
              <div className="flex-grow-1 pr2">
                <Button component="a" href={returnToLink}>
                  <FormattedMessage defaultMessage="Refresh the page" />
                </Button>
              </div>
              <div className="flex-grow-1 pl2">
                <Button component="a" href="/" variant="outlined" color="secondary">
                  <FormattedMessage defaultMessage="Carrot Home" />
                </Button>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </div>
  )
}

export { UnknownErrorOccurred }
